var React = require('react');

function Duties (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.4275 16.3601H20.1592L11.2864 7.4873C9.87242 8.90127 9.87242 11.195 11.2864 12.609L15.0375 16.3601H6.36219V11.5422C4.36169 11.5422 2.73975 13.1641 2.73975 15.1646V22.0369H26.8445C26.8445 19.5965 26.439 16.3616 22.4275 16.3616V16.3601Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Duties.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Duties;

Duties.default = Duties;
